export const environment = {
    name: 'production',
    production: true,
    testing: false,
    enableServiceWorker: true,
    allowSearchEngines: true,
    showPanics: false,
    apiOverride: undefined,
    showEnvironmentHint: false,
    urls: {
        root: 'https://tyt.com',
        accounts: 'https://accounts.tyt.com',
        purchase: 'https://accounts.tyt.com/join',
        // purchase: `https://accounts.tyt.com/join/eec3a06`; // "site-nav" offer set for tracking
        // purchase: `https://join.tyt.com/join`; // for classic vs modern H2H test, October 6, 2020
        donate: 'https://secure.actblue.com/donate/tytnetwork',
        platform: 'https://platform.tyt.com',
        cable: 'https://platform.tyt.com/cable',
        api: 'https://platform.tyt.com/api/v1',
        admin: 'https://platform.tyt.com',
        forums: 'https://discuss.tyt.com',
        bantaServer: 'https://banta.tyt.com',
        cdn: 'cdn2.tyt.com'
    },
    auth: {
        domain: '.tyt.com',
        cookie: 'tytauth',
        userCookie: 'tyt_user_uuid'
    },
    stripeKey: 'pk_0zIUNvWdQMQTgAAOcX1k9p5BOUXTz',
    googleCastAppId: 'F30612C0',
    spotId: 'sp_s81DnEgR',
    showDevTools: false,
    recaptchaV2SiteKey: '6LfORrIZAAAAADh6jtBF5aMhuEc3XfLjN4wBwepR',
    recaptchaV3SiteKey: '6LfsRbIZAAAAAMcH0NLIDxSqvJy3JNUs3XpWxQ4L',
    bugsnagKey: '100b690374ca57ef9bc9b16b1dd9c08a',
    firebase: {
        apiKey: "AIzaSyBCFYjNvgT-OKu8Lxio-LrO9RyYm_AWaAg",
        authDomain: "tyt-plus-b5a16.firebaseapp.com",
        databaseURL: "https://tyt-plus-b5a16.firebaseio.com",
        projectId: "tyt-plus-b5a16",
        storageBucket: "tyt-plus-b5a16.appspot.com",
        messagingSenderId: "453075902535",
        appId: "1:453075902535:web:dc2edb959e797a55459162",
        measurementId: "G-Q3C2VEYM6K"
    },
    useBanta: true
};
